import { gql, useMutation } from '@apollo/client'
import {
  MutationUserTokenBalanceChangeArgs,
  MutationUserTokenBalanceChangePayload,
} from 'src/generated'

const MUTATION_USER_TOKEN_BALANCE_CHANGE = gql`
  mutation UserTokenBalanceChange(
    $input: MutationUserTokenBalanceChangeInput!
  ) {
    userTokenBalanceChange(input: $input) {
      userId
      tokenBalance
    }
  }
`

const useUserTokenBalanceChangeMutation = () => {
  return useMutation<
    { userBanStatusChange: MutationUserTokenBalanceChangePayload },
    MutationUserTokenBalanceChangeArgs
  >(MUTATION_USER_TOKEN_BALANCE_CHANGE)
}

export default useUserTokenBalanceChangeMutation
